// Basic API state type
export type ApiState = {
    status: 'empty' | 'loading' | 'success' | 'error';
    isLoading: boolean;
    error: any;
    result?: any;
    endpoint?: string | null;
};

export type ApiAction =
    | { type: 'request_started'; endpoint?: string | null }
    | { type: 'request_success'; result: any; endpoint?: string | null }
    | { type: 'request_error'; error: any; endpoint?: string | null };

export const ApiReducer = (state: ApiState, action: ApiAction): ApiState => {
    switch (action.type) {
        case 'request_started':
            return {
                ...state,
                status: 'loading',
                isLoading: true,
                error: null,
                endpoint: action.endpoint || null,
            };
        case 'request_success':
            return {
                ...state,
                status: 'success',
                isLoading: false,
                error: null,
                result: action.result,
                endpoint: action.endpoint || null,
            };
        case 'request_error':
            return {
                ...state,
                status: 'error',
                isLoading: false,
                error: action.error,
                endpoint: action.endpoint || null,
            };
        default:
            return state;
    }
};
